import {
  SETTING_PAYMENT_METHODS_PAGE_REQUEST,
  SETTING_PAYMENT_METHODS_SET_PAYMENT_METHODS,
  SETTING_PAYMENT_METHODS_SET_OUTLET_STATUS,
  SETTING_PAYMENT_METHODS_SET_OUTLETS,
  SETTING_PAYMENT_METHODS_SET_SHOW_OUTLET_DETAIL_MODAL,
  SETTING_PAYMENT_METHODS_IS_SHOW_PAYMENT_LIST,
  SETTING_PAYMENT_METHODS_IS_SHOW_REGISTRATION_FORM,
  SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_BUTTON,
  SETTING_PAYMENT_METHODS_SET_PAYMENT_METHOD_KEY,
  SETTING_PAYMENT_METHODS_SET_OPEN_REGISTRATION_OUTLET_MODAL,
  SETTING_PAYMENT_METHODS_ON_CLICK_CANCEL_REGISTRATION,
  SETTING_PAYMENT_METHODS_SET_ACCORDION_ACTIVE_KEY,
  SETTING_PAYMENT_METHODS_SET_BANK_ACCOUNT_DATA,
  SETTING_PAYMENT_METHODS_ON_CLICK_SUBMIT_E_WALLET_PAYMENT,
  SETTING_PAYMENT_METHODS_ON_CLICK_SHOW_OUTLET_DETAIL_MODAL,
  SETTING_PAYMENT_METHODS_SET_OPEN_TERMS_AND_CONDITIONS_MODAL,
  SETTING_PAYMENT_METHODS_ON_CLICK_SHOW_TERMS_AND_CONDITIONS_MODAL,
  SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_ALL,
  SETTING_PAYMENT_METHODS_UPDATE_KTP_NPWP,
  SETTING_PAYMENT_METHODS_SET_OPEN_INFORMATION_MODAL,
  SETTING_PAYMENT_METHODS_SET_BANK_LIST,
  SETTING_PAYMENT_METHODS_SET_BUSINESS_BANK_ACCOUNT_LIST,
  SETTING_PAYMENT_METHODS_ON_CLICK_ADD_BANK_ACCOUNT,
  SETTING_PAYMENT_METHODS_SET_SHOW_BANK_ACCOUNT_MODAL_FORM,
  SETTING_PAYMENT_METHODS_ON_CLICK_ADD_BANK_ACCOUNT_OPEN_BANK_ACCOUNT_MODAL,
  SETTING_PAYMENT_METHODS_SET_SELECTED_PAYMENT_METHOD_LIST,
  SETTING_PAYMENT_METHODS_SHOW_MODAL_ASSIGN_OUTLETS_ON_REGISTRATION,
  SETTING_PAYMENT_METHODS_HIDE_MODAL_ASSIGN_OUTLETS_ON_REGISTRATION,
  SETTING_PAYMENT_METHODS_ADD_ASSIGN_OUTLET,
  SETTING_PAYMENT_METHODS_SET_UNLINK_OUTLETS,
  SETTING_PAYMENT_METHODS_SET_BANK_ACCOUNT_DETAIL,
  SETTING_PAYMENT_METHODS_SET_ASSIGNED_OUTLETS,
  SETTING_PAYMENT_METHODS_SET_PAYMENT_METHODS_OUTLET,
  SETTING_PAYMENT_METHODS_ON_CLICK_OUTLET_TO_BANK_ACCOUNT,
  SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_PAYMENT_METHOD_IN_NOTIFICATION,
  SETTING_PAYMENT_METHODS_ON_CLICK_DISMISS_PAYMENT_METHOD_IN_NOTIFICATION,
  SET_HAS_ACTIVATE_EWALLET,
  FETCH_EWALLET,
  SETTING_PAYMENT_METHODS_SET_WALLET_REGISTRATION_STATUS,
  SETTING_PAYMENT_METHODS_ACTIVATE_ALL_PAYMENT_METHOD,
  SETTING_PAYMENT_METHODS_SET_SHOW_BANK_STATUS_MODAL,
  SETTING_PAYMENT_METHODS_SET_KTB_STATUS,
  SETTING_PAYMENT_METHODS_REMAINING_PAYMENT_METHOD,
  SETTING_PAYMENT_METHODS_REMAINING_NEW_OUTLET,
} from './constants';

export function pageRequest() {
  return {
    type: SETTING_PAYMENT_METHODS_PAGE_REQUEST,
    payload: {},
  };
}

export function updateKtpNpwp(ktpNumber, npwpNumber, ktpName) {
  return {
    type: SETTING_PAYMENT_METHODS_UPDATE_KTP_NPWP,
    payload: {
      ktp_number: ktpNumber,
      npwp_number: npwpNumber,
      ktp_name: ktpName,
    },
  };
}

// ONCLICK

export function onClickActivateButton(
  selectedPaymentMethodList,
  userData,
  businessName
) {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_BUTTON,
    payload: { userData, businessName, selectedPaymentMethodList },
  };
}

export function onClickCancelRegistration() {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_CANCEL_REGISTRATION,
    payload: {},
  };
}

export function onClickSubmitEWalletPayment(
  paymentMethodList,
  formValue,
  outlets,
  business
) {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_SUBMIT_E_WALLET_PAYMENT,
    payload: { paymentMethodList, formValue, outlets, business },
  };
}

export function onClickShowOutletDetailModal(paymentMethod) {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_SHOW_OUTLET_DETAIL_MODAL,
    payload: { paymentMethod },
  };
}

export function onClickTermsAndConditions(paymentMethodKey) {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_SHOW_TERMS_AND_CONDITIONS_MODAL,
    payload: { paymentMethodKey },
  };
}

export function onClickActivateAll(paymentMethodId, outlets, userData) {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_ALL,
    payload: { paymentMethodId, outlets, userData },
  };
}

export function onClickAddBankAccount(data, prevBusinessBankAccount) {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_ADD_BANK_ACCOUNT,
    payload: { data, prevBusinessBankAccount },
  };
}

export function onClickAddBankAccountOpenBankAccountModal(
  isEditBankAccount = false,
  bankAccountValues = null
) {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_ADD_BANK_ACCOUNT_OPEN_BANK_ACCOUNT_MODAL,
    payload: { isEditBankAccount, bankAccountValues },
  };
}

// SETTER

export function setIsShowPaymentList(isShowPaymentList) {
  return {
    type: SETTING_PAYMENT_METHODS_IS_SHOW_PAYMENT_LIST,
    payload: { isShowPaymentList },
  };
}

export function setIsShowRegistrationForm(isShowRegistrationForm) {
  return {
    type: SETTING_PAYMENT_METHODS_IS_SHOW_REGISTRATION_FORM,
    payload: { isShowRegistrationForm },
  };
}

export function setPaymentMethodKey(paymentMethodKey) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_PAYMENT_METHOD_KEY,
    payload: { paymentMethodKey },
  };
}

export function setPaymentMethods(paymentMethods) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_PAYMENT_METHODS,
    payload: { paymentMethods },
  };
}

export function setOutletStatuses(outletStatus) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_OUTLET_STATUS,
    payload: { outletStatus },
  };
}

export function setOutlets(outlets) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_OUTLETS,
    payload: { outlets },
  };
}

export function setShowOutletDetailModal(openOutletDetailModal) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_SHOW_OUTLET_DETAIL_MODAL,
    payload: { openOutletDetailModal },
  };
}

export function setShowBankStatusModal(openBankStatusModal) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_SHOW_BANK_STATUS_MODAL,
    payload: { openBankStatusModal },
  };
}

export function setOpenRegistrationOutletModal(openRegistrationOutletModal) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_OPEN_REGISTRATION_OUTLET_MODAL,
    payload: { openRegistrationOutletModal },
  };
}

export function setActiveAccordionKey(activeAccordionKey) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_ACCORDION_ACTIVE_KEY,
    payload: { activeAccordionKey },
  };
}

export function setBankAccountData(bankAccountData) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_BANK_ACCOUNT_DATA,
    payload: { bankAccountData },
  };
}

export function setOpenTermsAndConditionsModal(openTermsAndConditionsModal) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_OPEN_TERMS_AND_CONDITIONS_MODAL,
    payload: { openTermsAndConditionsModal },
  };
}

export function setInformationModal(openInfoModal) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_OPEN_INFORMATION_MODAL,
    payload: { openInfoModal },
  };
}

export function setBankList(bankList) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_BANK_LIST,
    payload: { bankList },
  };
}

export function setBusinessBankAccountList(businessBankAccountList) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_BUSINESS_BANK_ACCOUNT_LIST,
    payload: { businessBankAccountList },
  };
}

export function setShowBankAccountModalForm(showBankAccountModalForm) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_SHOW_BANK_ACCOUNT_MODAL_FORM,
    payload: { showBankAccountModalForm },
  };
}

export function setSelectedPaymentMethodList(selectedPaymentMethodList) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_SELECTED_PAYMENT_METHOD_LIST,
    payload: { selectedPaymentMethodList },
  };
}

export function setWalletRegistrationStatus(status) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_WALLET_REGISTRATION_STATUS,
    payload: { status },
  };
}

export function setKybStatus(status) {
  return { type: SETTING_PAYMENT_METHODS_SET_KTB_STATUS, payload: { status } };
}

export function showModalAssignOutletsOnRegistration() {
  return {
    type: SETTING_PAYMENT_METHODS_SHOW_MODAL_ASSIGN_OUTLETS_ON_REGISTRATION,
    payload: {},
  };
}

export function hideModalAssignOutletsOnRegistration() {
  return {
    type: SETTING_PAYMENT_METHODS_HIDE_MODAL_ASSIGN_OUTLETS_ON_REGISTRATION,
    payload: {},
  };
}

export function onRegisterPaymentMethodAssignOutlet(bankAccountDetail) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_BANK_ACCOUNT_DETAIL,
    payload: { bankAccountDetail },
  };
}

export function setSelectedOutletsModal(outletList) {
  return {
    type: SETTING_PAYMENT_METHODS_ADD_ASSIGN_OUTLET,
    payload: { outletList },
  };
}

export function setUnlinkOutletsModal(outletList) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_UNLINK_OUTLETS,
    payload: { outletList },
  };
}

export function setAssignedOutlets(assignedOutlets) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_ASSIGNED_OUTLETS,
    payload: { assignedOutlets },
  };
}

export function setPaymentMethodsOutlets(paymentMethodOutlets) {
  return {
    type: SETTING_PAYMENT_METHODS_SET_PAYMENT_METHODS_OUTLET,
    payload: { paymentMethodOutlets },
  };
}

export function linkOutletToBankAccount(bank, selectedOutlets, unlinkOutlets) {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_OUTLET_TO_BANK_ACCOUNT,
    payload: {
      bank,
      selectedOutlets,
      unlinkOutlets,
    },
  };
}

export function sethasActivatedEwallet(hasActivatedEwallet) {
  return {
    type: SET_HAS_ACTIVATE_EWALLET,
    payload: { hasActivatedEwallet },
  };
}

export function fetchEwallet() {
  return {
    type: FETCH_EWALLET,
    payload: {},
  };
}

export function sendClevertapTrackerOnClickActivatePaymentMethodNotification() {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_ACTIVATE_PAYMENT_METHOD_IN_NOTIFICATION,
    payload: {},
  };
}

export function sendClevertapTrackerOnClickDismissPaymentMethodNotification() {
  return {
    type: SETTING_PAYMENT_METHODS_ON_CLICK_DISMISS_PAYMENT_METHOD_IN_NOTIFICATION,
    payload: {},
  };
}

export function activateAllPaymentMethod(payload) {
  return {
    type: SETTING_PAYMENT_METHODS_ACTIVATE_ALL_PAYMENT_METHOD,
    payload,
  };
}

export function activateRemainingPaymentMethod(payload) {
  return {
    type: SETTING_PAYMENT_METHODS_REMAINING_PAYMENT_METHOD,
    payload,
  };
}

export function activateRemainingNewOutlet(payload) {
  return {
    type: SETTING_PAYMENT_METHODS_REMAINING_NEW_OUTLET,
    payload,
  };
}
